import styled from 'styled-components';

export const MainWrapper = styled.div`
  border-radius: 6px;
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.colors.grayVariations.shadow};
  max-width: 773px;
  margin-bottom: 12px;
`;

export const ClosedElementContainer = styled.div<{ isExpanded: boolean }>`
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  ${({ isExpanded }) => !isExpanded && `max-height: 128px;`}

  & > div:first-child {
    width: 100%;
    max-width: 648px;

    & > :last-child {
      margin-bottom: 0;
    }

    ${({ isExpanded }) =>
      isExpanded
        ? `word-break: break-word; overflow-x: auto;`
        : `
          & > :first-child {
            word-break: break-word;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            margin-bottom: 0;
          }

          & > :not(:first-child) {
            display: none;
          }
    `}
  }

  & > div:last-child {
    align-self: flex-end;
  }
`;

export const IconsWrapper = styled.div`
  display: flex;
  & > div:first-child {
    margin-right: 30px;
  }
  cursor: pointer;
`;

export const ExpandContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  margin-bottom: 8px;
`;
